import React from 'react';
import { useMutation } from '@apollo/client';
import { gql } from '../../graphql/generated/gql';
import useNavigate from '../../utils/router/useNavigate';
import AdminProvisionForm from './AdminProvisionForm';

const CREATE_PROVISION_MUTATION = gql(/** @complexity 2 */ `
  mutation createProvision(
    $name: String!
    $type: ProvisionType!
    $urlEnabled: Boolean!
    $favoriteIds: [ID!]
    $memberIds: [ID!]
  ) {
    createProvision(
      name: $name
      type: $type
      urlEnabled: $urlEnabled
      favoriteIds: $favoriteIds
      memberIds: $memberIds
    ) {
      id
    }
  }
`);

const AdminProvisionNewView = () => {
  const navigate = useNavigate();
  const [createProvision] = useMutation(CREATE_PROVISION_MUTATION);

  return (
    <AdminProvisionForm
      onSubmit={(values) => {
        return createProvision({
          variables: values,
        }).then(({ data }) => {
          const id = data?.createProvision?.id;

          if (id) {
            navigate(`/admin/provisions/${id}`);
          }
        });
      }}
    />
  );
};

export default AdminProvisionNewView;
